export enum ProjectStateType {
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
  PLANNED = 'Planned',
  ENDED = 'Ended',
  EXTENDED = 'Extended',
  ARCHIVED = 'Archived'
}
